"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./cookie'));
__export(require('./unmanagedCookie'));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-cookies/index.js
// module id = ./node_modules/ng2-cookies/index.js
// module chunks = vendor